import i from "clsx";
import t from "react";
import { s as l } from "../../../../../RideGlyph.module-CgKw9y7i.mjs";
function d({
  size: e = "small",
  accessibilityTitle: C = "glyph soat solid",
  className: r,
  "data-testid": s,
  fill: a,
  stroke: o
}) {
  const H = () => i(r, l["ride-glyph"], {
    [l[`size-${e}`]]: e
  });
  return /* @__PURE__ */ t.createElement("div", { className: H(), "data-testid": s }, /* @__PURE__ */ t.createElement(
    "svg",
    {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: a || "#03050F",
      stroke: o || "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    C && /* @__PURE__ */ t.createElement("title", null, C),
    /* @__PURE__ */ t.createElement("path", { d: "M18.2601 16.43H19.3101L18.7901 14.77L18.2601 16.43ZM14.0701 14.77C13.4301 14.77 12.9601 15.26 12.9601 16C12.9601 16.74 13.4301 17.23 14.0701 17.23C14.7101 17.23 15.1801 16.74 15.1801 16C15.1801 15.26 14.7101 14.77 14.0701 14.77ZM27.5501 14.47L23.1201 6.24003C22.5501 5.18003 21.4501 4.53003 20.2501 4.53003H11.7501C10.5501 4.53003 9.45006 5.19003 8.88006 6.24003L4.45006 14.47C3.93006 15.43 3.93006 16.58 4.45006 17.53L8.88006 25.76C9.45006 26.82 10.5501 27.47 11.7501 27.47H20.2501C21.4501 27.47 22.5501 26.81 23.1201 25.76L27.5501 17.53C28.0701 16.57 28.0701 15.43 27.5501 14.47V14.47ZM9.49006 18.33C8.36006 18.33 7.65006 17.72 7.65006 16.78H8.79006C8.81006 17.12 9.10006 17.33 9.54006 17.33C9.96006 17.33 10.1401 17.16 10.1401 16.9C10.1401 16.69 10.0001 16.57 9.56006 16.48L8.86006 16.35C8.09006 16.21 7.65006 15.79 7.65006 15.13C7.65006 14.27 8.38006 13.68 9.44006 13.68C10.5001 13.68 11.2401 14.27 11.2501 15.17H10.1101C10.0801 14.87 9.85006 14.68 9.42006 14.68C9.03006 14.68 8.82006 14.84 8.82006 15.08C8.82006 15.25 8.94006 15.37 9.38006 15.44L10.0801 15.57C10.8901 15.72 11.3101 16.15 11.3101 16.84C11.3101 17.72 10.6301 18.34 9.49006 18.34V18.33ZM14.0701 18.33C12.7601 18.33 11.7501 17.39 11.7501 16C11.7501 14.61 12.7601 13.67 14.0701 13.67C15.3801 13.67 16.3901 14.61 16.3901 16C16.3901 17.39 15.3801 18.33 14.0701 18.33V18.33ZM19.8901 18.28L19.6201 17.41H17.9601L17.6901 18.28H16.4901L18.0301 13.73H19.5801L21.1201 18.28H19.8901ZM24.3501 14.82H23.1501V18.28H21.9701V14.82H20.7701V13.73H24.3601V14.82H24.3501Z" })
  ));
}
export {
  d as RideGlSoatSolid
};
